import { createFileRoute } from "@tanstack/react-router";
import { PageHeader } from "@/components/app/shell/page-header";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useFacility } from "@/lib/facility/facility";
import { KnowledgePane } from "./-components/knowledge-pane";
import { PersonaPane } from "./-components/persona-pane";
import { PromptPane } from "./-components/prompt-pane";
import { OneBuildingCard } from "@/components/app/workspace/one-building-card";

export const Route = createFileRoute("/_authenticated/_front-desk/sarah/agent/")({
  component: Agent,
});

/** How the front desk speaks and what it knows. */
function Agent() {
  const { facilityId } = useFacility();
  const realFacility = facilityId === "all" ? null : facilityId;

  if (!realFacility) {
    return (
      <>
        <PageHeader title="Front desk agent" meta="How the front desk speaks and what it knows." />
        <OneBuildingCard prompt="Choose a building. Each one answers its own telephone." />
      </>
    );
  }

  return (
    <>
      <PageHeader
        title="Front desk agent"
        meta="How the front desk speaks and what it knows. Changes apply to the next call."
      />
      <Tabs defaultValue="prompt">
        <TabsList>
          <TabsTrigger value="prompt">Prompt</TabsTrigger>
          <TabsTrigger value="knowledge">What it knows</TabsTrigger>
          <TabsTrigger value="persona">How it sounds</TabsTrigger>
        </TabsList>
        <TabsContent value="prompt">
          <PromptPane facilityId={realFacility} />
        </TabsContent>
        <TabsContent value="knowledge">
          <KnowledgePane facilityId={realFacility} />
        </TabsContent>
        <TabsContent value="persona">
          <PersonaPane facilityId={realFacility} />
        </TabsContent>
      </Tabs>
    </>
  );
}
